<script lang="ts" setup>
import { computed } from 'vue'
import type { Props } from './types'
import './_index.scss'

const props = withDefaults(defineProps<Props>(), {
  maxVisible: 3
})
const { t } = useI18n()

const visibleAvatars = computed(() => props.avatars.slice(0, props.maxVisible))
const hiddenAvatars = computed(() => props.avatars.slice(props.maxVisible))
</script>

<script lang="ts">
export default {
  name: 'AvatarGroup'
}
</script>

<template>
  <div class="avatar-group flex">
    <div
      v-for="(avatar, index) in visibleAvatars"
      :key="index"
      class="avatar-group__avatar border-2 border-carbon-800 rounded-full w-40 h-40 overflow-hidden">
      <img
        :src="avatar.src"
        :alt="avatar.alt"
        :title="avatar?.title"
        class="w-full h-full object-cover">
    </div>

    <div
      v-if="hiddenAvatars.length"
      :title="t('seeOther', { count: hiddenAvatars.length }, hiddenAvatars.length)"
      class="avatar-group__others-counter bg-carbon-800 text-white rounded-full w-40 h-40 text-14 flex justify-center items-center -ml-14">
      +{{ hiddenAvatars.length }}
    </div>
  </div>
</template>

<i18n src="./i18n.json" />
